const role = {
	name: 'Role | Roles',
	fields: {
		name: 'Role',
		hp_id: 'ID',
		em: 'Type',
		persons_count: 'Quantity',
		building: {
			hp_id: 'Liegenschaft',
		},
		unit: {
			hp_id: 'Unit',
		},
		role: {
			hp_id: 'Type',
		},
		started_at: 'From',
		ended_at: 'To',
	},
}

export default role
